import { EntityType } from '../../../models/enums';
import { GenericColDef, CellTemplateType, AlignDirection, FilterTemplateType } from '../../../models/grid-context';

export enum DocumentListColumnType {
    attachmentCount = 'attachmentCount',
    author = 'author',
    smfChatId = 'smfChatId',
    checkbox = 'checkbox',
    contextMenu = 'contextMenu',
    createdtime = 'createdtime',
    dateprimary = 'dateprimary',
    datescanned = 'datescanned',
    smfDataType = 'smfDataType',
    date_or_lastmodifiedtime = 'date_or_lastmodifiedtime',
    docid = 'docid',
    docnum = 'docnum',
    docnumex = 'docnumex',
    familyThread = 'familyThread',
    filename = 'filename',
    filetype = 'filetype',
    from = 'from',
    fromName = 'fromName',
    importpath = 'importpath',
    isAttachment = 'isAttachment',
    lastUpdate = 'lastUpdate',
    smfMessageBody = 'smfMessageBody',
    parsingstatus = 'parsingstatus',
    responsive = 'responsive',
    received = 'received',
    score = 'score',
    sent = 'sent',
    size = 'size',
    tags = 'tags',
    to = 'to',
    toName = 'toName',
    startDate = 'startDate',
    subject = 'subject',
    createdtimeException = 'createdtimeException',
    addHistoryUsername = 'addHistoryUsername',
    addHistoryComments = 'addHistoryComments',
    addHistoryTime = 'addHistoryTime',
    volume = 'volume',
    percentCommonTerms = 'percentCommonTerms',
    group = 'group',
    auxparsingstatus = 'auxparsingstatus'
}

export const allColumnDefs: ReadonlyMap<DocumentListColumnType, (hide: boolean) => GenericColDef> = new Map<DocumentListColumnType, (hide: boolean) => GenericColDef>([
    [DocumentListColumnType.checkbox, (hide: boolean) => <GenericColDef>{
        colId: 'checkbox',
        checkboxSelection: true, headerCheckboxSelection: true,
        minWidth: 36, maxWidth: 36, width: 36,
        suppressSizeToFit: true, suppressMovable: true
    }],
    [DocumentListColumnType.contextMenu, (hide: boolean) => <GenericColDef>{
        cellTemplateType: CellTemplateType.contextMenu,
        minWidth: 30, maxWidth: 30, width: 30,
        suppressSizeToFit: true,
        suppressMovable: true
    }],
    [DocumentListColumnType.docnum, (hide: boolean) => <GenericColDef>{
        headerName: 'Doc Number', field: 'docnum', sortBy: 'docnum',
        width: 100,
        hide: hide
    }],
    [DocumentListColumnType.docnumex, (hide: boolean) => <GenericColDef>{
        headerName: 'Doc Number', field: 'docnum',
        width: 100,
        hide: hide
    }],
    [DocumentListColumnType.familyThread, (hide: boolean) => <GenericColDef>{
        headerName: 'Family / Thread',
        headerAlignDirection: AlignDirection.center,
        cellTemplateType: CellTemplateType.docListFamilyThread,
        minWidth: 120, maxWidth: 120, width: 120,
        suppressSizeToFit: true,
        hide: hide,
        colId: 'familyThread'
    }],
    [DocumentListColumnType.tags, (hide: boolean) => <GenericColDef>{
        headerName: 'Tags', field: 'tagList',
        headerAlignDirection: AlignDirection.center,
        cellTemplateType: CellTemplateType.tagList,
        minWidth: 80, maxWidth: 80, width: 80,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.filename, (hide: boolean) => <GenericColDef>{
        headerName: 'Name', field: 'displayName', sortBy: 'filename',
        cellTemplateType: CellTemplateType.nameIconLabel,
        lockVisible: true
    }],
    [DocumentListColumnType.smfMessageBody, (hide: boolean) => <GenericColDef>{
        headerName: 'Message', field: 'smfMessageBody', sortBy: 'smfMessageBody',
        cellTemplateType: CellTemplateType.nameIconLabel,
        lockVisible: true
    }],
    [DocumentListColumnType.to, (hide: boolean) => <GenericColDef>{
        headerName: 'To', field: 'to', sortBy: 'to',
        hide: hide
    }],
    [DocumentListColumnType.toName, (hide: boolean) => <GenericColDef>{
        headerName: 'To', field: 'toName', sortBy: 'toName',
        hide: hide
    }],
    [DocumentListColumnType.smfChatId, (hide: boolean) => <GenericColDef>{
        headerName: 'Chat ID', field: 'smfChatId', sortBy: 'smfChatId',
        hide: hide
    }],
    [DocumentListColumnType.smfDataType, (hide: boolean) => <GenericColDef>{
        headerName: 'Data Type', field: 'smfDataType', sortBy: 'smfDataType',
        hide: hide
    }],
    [DocumentListColumnType.docid, (hide: boolean) => <GenericColDef>{
        headerName: 'Doc ID', field: 'docid', sortBy: 'docid',
        width: 130,
        hide: hide
    }],
    [DocumentListColumnType.responsive, (hide: boolean) => <GenericColDef>{
        headerName: 'Reason Code', field: 'responsive', sortBy: 'responsive',
        width: 110,
        hide: hide
    }],
    [DocumentListColumnType.volume, (hide: boolean) => <GenericColDef>{
        headerName: 'Volume', field: 'volume', sortBy: 'volume',
        headerAlignDirection: AlignDirection.right, cellAlignDirection: AlignDirection.right,
        width: 100,
        hide: hide
    }],
    [DocumentListColumnType.size, (hide: boolean) => <GenericColDef>{
        headerName: 'Size', field: 'size', sortBy: 'size',
        headerAlignDirection: AlignDirection.right, cellAlignDirection: AlignDirection.right,
        width: 100,
        hide: hide
    }],
    [DocumentListColumnType.dateprimary, (hide: boolean) => <GenericColDef>{
        headerName: 'Date', field: 'dateprimary', sortBy: 'dateprimary',
        headerAlignDirection: AlignDirection.right,
        width: 147,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.date_or_lastmodifiedtime, (hide: boolean) => <GenericColDef>{
        headerName: 'Date', field: 'date_or_lastmodifiedtime', sortBy: 'date_or_lastmodifiedtime',
        headerAlignDirection: AlignDirection.right,
        width: 147,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.sent, (hide: boolean) => <GenericColDef>{
        headerName: 'Sent', field: 'sent', sortBy: 'sent',
        width: 147,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.received, (hide: boolean) => <GenericColDef>{
        headerName: 'Received', field: 'received', sortBy: 'received',
        width: 147,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.from, (hide: boolean) => <GenericColDef>{
        headerName: 'Author', field: 'from', sortBy: 'from',
        hide: hide
    }],
    [DocumentListColumnType.fromName, (hide: boolean) => <GenericColDef>{
        headerName: 'From', field: 'fromName', sortBy: 'fromName',
        hide: hide
    }],
    [DocumentListColumnType.createdtime, (hide: boolean) => <GenericColDef>{
        headerName: 'Date Created', field: 'createdtime', sortBy: 'createdtime',
        headerAlignDirection: AlignDirection.right,
        width: 147,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.datescanned, (hide: boolean) => <GenericColDef>{
        headerName: 'Scan Date', field: 'datescanned', sortBy: 'datescanned',
        headerAlignDirection: AlignDirection.right,
        width: 147,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.attachmentCount, (hide: boolean) => <GenericColDef>{
        headerName: 'Attachments', field: 'attachmentCount',
        width: 100,
        hide: hide
    }],
    [DocumentListColumnType.isAttachment, (hide: boolean) => <GenericColDef>{
        headerName: 'Is Attachment',
        field: 'isAttachment',
        cellTemplateType: CellTemplateType.iconSwitch,
        cellRendererParams: { iconOnClass: 'fa-check color-grey-10' },
        headerAlignDirection: AlignDirection.center,
        width: 108,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.parsingstatus, (hide: boolean) => <GenericColDef>{
        headerName: 'Parsing Status',
        field: 'parsingstatus',
        width: 140,
        hide: hide
    }],
    [DocumentListColumnType.importpath, (hide: boolean) => <GenericColDef>{
        headerName: 'Import Path',
        field: 'importpath',
        hide: hide
    }],
    [DocumentListColumnType.filetype, (hide: boolean) => <GenericColDef>{
        headerName: 'File Type',
        field: 'filetype',
        hide: hide,
    }],
    [DocumentListColumnType.auxparsingstatus, (hide: boolean) => <GenericColDef>{
        headerName: 'Aux Parsing Status',
        field: 'auxparsingstatus',
        hide: hide,
    }],
    [DocumentListColumnType.score, (hide: boolean) => <GenericColDef>{
        headerName: 'Score', sortBy: 'score',
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        field: 'score',
        minWidth: 70, maxWidth: 70, width: 70,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.author, (hide: boolean) => <GenericColDef>{
        headerName: 'Author', sortBy: 'author',
        headerAlignDirection: AlignDirection.left,
        cellAlignDirection: AlignDirection.left,
        hide: hide,
        field: 'author',
        valueGetter: function tokenNameGetter(params) {
            let author = params.data.author;
            author = author.replace(/\r?\n|\r/g, ' ').replace(/<br\s*\/?>/gi, ' ');
            return author;
        }
    }],
    [DocumentListColumnType.startDate, (hide: boolean) => <GenericColDef>{
        headerName: 'First Message', field: 'startDate', sortBy: 'startDate',
        cellTemplateType: CellTemplateType.date,
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        hide: hide
    }],
    [DocumentListColumnType.lastUpdate, (hide: boolean) => <GenericColDef>{
        headerName: 'Last Message', field: 'lastUpdate', sortBy: 'lastUpdate',
        cellTemplateType: CellTemplateType.date,
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        hide: hide
    }],
    [DocumentListColumnType.subject, (hide: boolean) => <GenericColDef>{
        headerName: 'Name', field: 'subject', sortBy: 'subject',
        cellTemplateType: CellTemplateType.nameIconLabel,
        headerAlignDirection: AlignDirection.left,
        cellAlignDirection: AlignDirection.left,
        lockVisible: true
    }],
    [DocumentListColumnType.createdtimeException, (hide: boolean) => <GenericColDef>{
        headerName: 'Date Created', field: 'createdtime', sortBy: 'createdtime',
        headerAlignDirection: AlignDirection.right,
        width: 147,
        suppressSizeToFit: true,
        hide: hide
    }],
    [DocumentListColumnType.addHistoryUsername, (hide: boolean) => <GenericColDef>{
        headerName: 'Removed By', field: 'add_history_username',
        hide: hide,
        colId: DocumentListColumnType.addHistoryUsername
    }],
    [DocumentListColumnType.addHistoryComments, (hide: boolean) => <GenericColDef>{
        headerName: 'Comments', field: 'add_history_comments',
        hide: hide,
        colId: DocumentListColumnType.addHistoryComments
    }],
    [DocumentListColumnType.addHistoryTime, (hide: boolean) => <GenericColDef>{
        headerName: 'Date Sent to Discard Pile', field: 'add_history_time', 
        sortBy: 'add_to_workingset',
        width: 167,
        suppressSizeToFit: true,
        hide: hide,
        headerAlignDirection: AlignDirection.right,
        cellAlignDirection: AlignDirection.right,
        colId: DocumentListColumnType.addHistoryTime
    }],
    [DocumentListColumnType.percentCommonTerms, (hide: boolean) => <GenericColDef>{
        headerName: '% Terms', field: 'percentCommonTerms', sortBy: 'percentCommonTerms',
        hide: hide,
        suppressSizeToFit: true,
        width: 147
    }],
    [DocumentListColumnType.group, (hide: boolean) => <GenericColDef>{
        headerName: 'Group', field: 'group', sortBy: 'group'
    }]
]);

export const ReorderedDocumentListColumnInfo: Map<EntityType, Array<GenericColDef>> = new Map<EntityType, Array<GenericColDef>>([

])

export const DocumentListColumnInfo: ReadonlyMap<EntityType, Array<GenericColDef>> = new Map<EntityType, Array<GenericColDef>>([
    [EntityType.import, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.date_or_lastmodifiedtime)(false),
        allColumnDefs.get(DocumentListColumnType.author)(true),
        allColumnDefs.get(DocumentListColumnType.datescanned)(true),
        allColumnDefs.get(DocumentListColumnType.createdtime)(true),
        allColumnDefs.get(DocumentListColumnType.attachmentCount)(true),
        allColumnDefs.get(DocumentListColumnType.isAttachment)(true),
        allColumnDefs.get(DocumentListColumnType.parsingstatus)(true),
        allColumnDefs.get(DocumentListColumnType.importpath)(true),
        allColumnDefs.get(DocumentListColumnType.filetype)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false),
    )],
    [EntityType.projectData, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.clusterView, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.score)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.comparison, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.emailThread, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.subject)(false),
        allColumnDefs.get(DocumentListColumnType.startDate)(false),
        allColumnDefs.get(DocumentListColumnType.lastUpdate)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.shortMessageThread, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.smfMessageBody)(false),
        allColumnDefs.get(DocumentListColumnType.fromName)(false),
        allColumnDefs.get(DocumentListColumnType.toName)(false),
        allColumnDefs.get(DocumentListColumnType.smfChatId)(false),
        allColumnDefs.get(DocumentListColumnType.smfDataType)(false),
        allColumnDefs.get(DocumentListColumnType.startDate)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.shortMessageThreadDocList, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.smfMessageBody)(false),
        allColumnDefs.get(DocumentListColumnType.fromName)(false),
        allColumnDefs.get(DocumentListColumnType.toName)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.exceptionView, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnumex)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.from)(true),
        allColumnDefs.get(DocumentListColumnType.datescanned)(true),
        allColumnDefs.get(DocumentListColumnType.createdtimeException)(true),
        allColumnDefs.get(DocumentListColumnType.attachmentCount)(true),
        allColumnDefs.get(DocumentListColumnType.isAttachment)(true),
        allColumnDefs.get(DocumentListColumnType.parsingstatus)(false),
        allColumnDefs.get(DocumentListColumnType.importpath)(true),
        allColumnDefs.get(DocumentListColumnType.filetype)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.discardPile, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.addHistoryTime)(false),        
        allColumnDefs.get(DocumentListColumnType.addHistoryUsername)(true),
        allColumnDefs.get(DocumentListColumnType.addHistoryComments)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.export, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(true),
        allColumnDefs.get(DocumentListColumnType.docid)(false),
        allColumnDefs.get(DocumentListColumnType.responsive)(false),
        allColumnDefs.get(DocumentListColumnType.volume)(false),
        allColumnDefs.get(DocumentListColumnType.date_or_lastmodifiedtime)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.exportVolume, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(true),
        allColumnDefs.get(DocumentListColumnType.docid)(false),
        allColumnDefs.get(DocumentListColumnType.responsive)(false),
        allColumnDefs.get(DocumentListColumnType.volume)(false),
        allColumnDefs.get(DocumentListColumnType.date_or_lastmodifiedtime)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.savedSearch, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.score)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.searchResult, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.score)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.searchResultExportErrors, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.parsingstatus)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.sampleSet, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.searchResultImport, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.date_or_lastmodifiedtime)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.score)(false),
        allColumnDefs.get(DocumentListColumnType.author)(true),
        allColumnDefs.get(DocumentListColumnType.datescanned)(true),
        allColumnDefs.get(DocumentListColumnType.createdtime)(true),
        allColumnDefs.get(DocumentListColumnType.attachmentCount)(true),
        allColumnDefs.get(DocumentListColumnType.isAttachment)(true),
        allColumnDefs.get(DocumentListColumnType.importpath)(true),
        allColumnDefs.get(DocumentListColumnType.filetype)(true),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.similaritySearchResult, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.score)(false),
        allColumnDefs.get(DocumentListColumnType.percentCommonTerms)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )],
    [EntityType.exactOrContentDuplicatesSearchResult, new Array<GenericColDef>(
        allColumnDefs.get(DocumentListColumnType.checkbox)(false),
        allColumnDefs.get(DocumentListColumnType.docnum)(false),
        allColumnDefs.get(DocumentListColumnType.familyThread)(false),
        allColumnDefs.get(DocumentListColumnType.tags)(false),
        allColumnDefs.get(DocumentListColumnType.filename)(false),
        allColumnDefs.get(DocumentListColumnType.to)(false),
        allColumnDefs.get(DocumentListColumnType.size)(false),
        allColumnDefs.get(DocumentListColumnType.dateprimary)(false),
        allColumnDefs.get(DocumentListColumnType.sent)(true),
        allColumnDefs.get(DocumentListColumnType.received)(true),
        allColumnDefs.get(DocumentListColumnType.group)(false),
        allColumnDefs.get(DocumentListColumnType.contextMenu)(false)
    )]
]);
